import { createFileRoute, notFound } from '@tanstack/react-router';
import { z } from 'zod';
import OrganizationSetup from '../../../pages/organizationSetup/OrganizationSetup';
import { VIEW_ORGANIZATION_SETUP_PAGE } from '../../../utils/permissions';

// Only the org id travels in the URL; name/logo/etc. are re-fetched by id.
// (The logo is a base64 data URI — putting it in the URL caused HTTP 414.)
const searchSchema = z.object({
  organizationId: z.string().optional(),
});

export const Route = createFileRoute(
  '/_authenticated/_navbar/organization-setup'
)({
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => {
    if (!context.auth.hasPermission(VIEW_ORGANIZATION_SETUP_PAGE)) {
      throw notFound();
    }
  },
  component: OrganizationSetup,
});
